<template>
  <div v-if="!showDettaglio">
    <h3 class="info-center">Stampante Fiscale</h3>
    <h4 class="info-center red blink" v-if="infoStampante.errore">{{infoStampante.errore}}</h4>
    <h4 class="info-center orange blink" v-if="infoStampante.lowDGFE">Attenzione spazio DGFE minore del 10%. <br/>Contattare l'assistenza </h4>
    <van-row type="flex" justify="space-around">
      <van-col span="10">
        <van-cell-group>
          <van-cell title="Matricola" :value="infoStampante.matricola" />
          <van-cell title="Firmware" :value="infoStampante.firmware" />
          <van-cell title="Spazio libero DGFE" :value="infoStampante.liberoDGFE" />
          <van-cell title="Data/ora" :value="infoStampante.data"/>
          <van-button v-if="vv.mostraTutto || (vv.mostraAggiornaOra && !vv.mostraCambioModo)" type="info" plain size="large" @click="aggiornaOra">Aggiorna ora Stampante</van-button>
          <van-cell title="Ultimo azzeramento" :value="infoStampante.lastZ" />
          <van-cell title="Ultimo documento" :value="infoStampante.lastDocF" />
        </van-cell-group>
      </van-col>
      <van-col span="10">
        <van-cell-group>
          <van-cell title="File pendenti" :value="infoStampante.filePendenti"/>
          <van-cell v-if="vv.mostraTutto || infoStampante.oldFile" title="File più vecchio" :value="infoStampante.oldFile"/>
          <van-button v-if="vv.mostraTutto || vv.mostraInvioPendenti" type="primary" plain size="large" @click="invioPendenti">Invia file pendenti</van-button>
          <van-cell title="Modo" :value="infoStampante.modo" />
          <van-button v-if="vv.mostraTutto || vv.mostraCambioModo" type="primary" plain size="large" @click="modoReg">Passa a modo REG</van-button>
          <van-cell title="Stato" :value="infoStampante.stato" :value-class="vv.classeInattiva" :title-class="vv.classeInattiva"  size="large"/>
          <van-button v-if="vv.mostraTutto || (vv.mostraCambioStato && !vv.mostraCambioModo)" type="warning" plain size="large" @click="eseguiChiusura">Chiusura giornaliera</van-button>
          <van-cell title="Indirizzo IP" :value="infoStampante.ipStampante" />
        </van-cell-group>
      </van-col>
    </van-row>
    <div class="test-stampante" :class="{ 'fatture': fatture }">
      <van-button plain small type="primary" style="margin-right: 10px;" @click="testStampante()">Test Stampante</van-button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    infoStampante: Object,
    vv: Object,
    showDettaglio: Boolean,
    fatture: Boolean
  },
  data() {
    return {
      printerStatus: null
    }
  },
  methods: {
    aggiornaOra() {
      this.$emit('eventi', { tipo: 'aggiornaOra' })
    },
    invioPendenti() {
      this.$emit('eventi', { tipo: 'invioPendenti' })
    },
    modoReg() {
      this.$emit('eventi', { tipo: 'modoReg' })
    },
    eseguiChiusura() {
      this.$emit('eventi', { tipo: 'eseguiChiusura' })
    },
    testStampante() {
      this.$emit('eventi', { tipo: 'testStampante' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup-stampante {
    width: 40vw;
    height: 60vh; /* 47 Attenzione lasciare spazio per pulsanti aggiornamento */
  }

  @media all and (max-width: 1800px) {
    .popup-stampante {
      width: 50vw;
      height: 67vh;
    }
  }

  @media all and (max-width: 1400px) {
    .popup-stampante {
      width: 55vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
    }
  }

  @media all and (max-width: 1024px) {
    .popup-stampante {
      width: 80vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
    }
  }

  .info-center {
    text-align: center;
    &.red {
      color: red;
    }
    &.orange {
      color: #ff8800;
    }
  }
  .testo-inattiva {
    color: red;
    font-weight: bold;
  }
  .popup-stampante .van-cell {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .blink {
    animation: blinker 1s step-start infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }

  .test-stampante {
    position: absolute;
    bottom: 160px;
    left: auto;
    right: 30px;
    &.fatture {
      bottom: 36vh;
    }
  }
</style>
